import React from 'react';
import { FormattedMessage } from 'react-intl';

const Region = ({ id, name }) => {
  return (
    <>
      <span className="interactive-size-guide__region-name ellipsis">
        <FormattedMessage
          id="interactiveSizeGuide.dropdown"
          description="Region sizes"
          values={{ 0: <FormattedMessage id={name} /> }}
        />
      </span>
      <span className="interactive-size-guide__region-flag">
        <img src={`/assets/images/flags/${id}.svg`} height="18px" alt={`${id} flag`} />
      </span>
    </>
  );
};

export default Region;
